import { render, staticRenderFns } from "./LoldocupMainSymbol.vue?vue&type=template&id=5e866c60&"
import script from "./LoldocupMainSymbol.vue?vue&type=script&lang=js&"
export * from "./LoldocupMainSymbol.vue?vue&type=script&lang=js&"
import style0 from "./LoldocupMainSymbol.vue?vue&type=style&index=0&id=5e866c60&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports